export default {
  default_browser_tag: 'FoodAmigos - Order online',
  seo: {
    title: '{{name}} - Essen online bestellen in {{city}}',
    description: '{{name}} in {{city}}. Offizielle Menü Karte. Spare Geld und bestelle hier online.',
  },
};
